import React from 'react';
export function Footer() {
  return <footer className="w-full bg-villa-bg border-t border-[var(--color-border-subtle)] py-16 px-6 md:px-10 transition-colors duration-500" data-id="element-62">
      <div className="max-w-6xl mx-auto" data-id="element-63">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8" data-id="element-64">
          <div data-id="element-65">
            <p className="font-playfair text-villa-text text-lg tracking-[0.2em] font-medium mb-3" data-id="element-66">
              MEZÍRKA
            </p>
            <p className="font-inter text-villa-text/30 text-sm font-light" data-id="element-67">
              Mezírka 3, Brno, Czech Republic
            </p>
          </div>

          <p className="font-inter text-villa-text/20 text-[11px] font-light leading-relaxed max-w-md md:text-right" data-id="element-68">
            Tento web slouží pouze k informačním účelům. Všechny rozměry a
            vizualizace jsou orientační. Developer si vyhrazuje právo na změny.
            © {new Date().getFullYear()} FLATS DEVELOPMENT BRNO s.r.o. Všechna
            práva vyhrazena.
          </p>
        </div>
      </div>
    </footer>;
}